module.exports = __webpack_public_path__ + "assets/linked-in-logo.1bc9437e.svg";